import { z } from "zod";

const agendaColumnSettingsZodObject = z.object({
    showBlocked: z.boolean(),
    showDropIns: z.boolean(),
    showExtras: z.boolean(),
});

type AgendaColumnSettings = z.infer<typeof agendaColumnSettingsZodObject>;

const agendaColumnSettingsFactory = (
    settings: Partial<AgendaColumnSettings>,
): AgendaColumnSettings => {
    return agendaColumnSettingsZodObject.parse(settings);
};

export { agendaColumnSettingsFactory, agendaColumnSettingsZodObject };
export type { AgendaColumnSettings };
